import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface ApiState {
  authorDetails: any;
  loading: any;
  error: string | null;

  // page:any;
  // status:any;
}

const initialState: ApiState = {
  authorDetails: [],
  loading: true,
  error: null,
  // page:1,
  // status:null,
};

export const fetchAuthorDetails = createAsyncThunk(
  'authorDetails/fetchAuthorDetails',
  async (authorId:any ,{ getState, dispatch, rejectWithValue }) => {
    let state: any = getState();

    try {
      const config:any = {
        headers: {
          Authorization: (window as any).NHQ?.token && (window as any).NHQ?.token !== "" ? `Basic ${(window as any).NHQ?.token}` : `Basic ${process.env.REACT_APP_AUTH_TOKEN}`,
        },
        credentials: 'omit', // or 'same-origin' or 'include' based on your needs
      };

      const queryParams = new URLSearchParams();
      // if (page) queryParams.append('page', page);
      // if (status !== 'all' && status !== null) queryParams.append('status', status);
      // if (search) queryParams.append('search', search);

      const response:any = await fetch(`https://www.notablehq.com/wp-json/nhq/v1/author/${authorId}?fields=all${queryParams}`, config);
      if (!response.ok) {
        const error = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}. Message: ${error}`);
      }

      const data = await response.json();
      return data;
    } catch (error:any) {
      console.error('Error fetching user collections:', error);
      throw error;
    }
  }
);

const authorDetailsSlice = createSlice({
  name: 'authorDetails',
  initialState,
  reducers: {
    // setSearch: (state, action) => {
    //   state.searchValue = action.payload;
    // },
    // setSortBy: (state, action) => {
    //   state.sortBy = action.payload;
    // },
    // setPage: (state, action) => {
      // state.page = action.payload;
    // },
    // setStatus: (state, action) => {
      // state.status = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthorDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuthorDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.authorDetails = action.payload;
      })
      .addCase(fetchAuthorDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch data';
      });
  },
});

export default authorDetailsSlice.reducer;
// export const {setStatus, setPage,  } = userCollectionsSlice.actions;
// export { fetchUserCollections };
